import { FC, memo } from 'react';
import { Modal } from 'shared/ui/Modal';
import { Form } from 'features/Form';
import { UserRequestDto } from 'shared/api';
import { USER_FORM_FIELDS } from '../../constants/userConstants';

interface UserFormProps {
  isOpen: boolean;
  editingUser: UserRequestDto | null;
  isEditing: boolean;
  onSubmit: (data: UserRequestDto) => void;
  onCancel: () => void;
}

export const UserForm: FC<UserFormProps> = memo(({
  isOpen,
  editingUser,
  isEditing,
  onSubmit,
  onCancel,
}) => (
  <Modal
    title={isEditing ? 'Редактировать пользователя' : 'Создать пользователя'}
    open={isOpen}
    onCancel={onCancel}
    footer={null}
    width={600}
  >
    <Form
      fields={USER_FORM_FIELDS}
      initialValues={editingUser || {}}
      onSubmit={onSubmit}
    />
  </Modal>
));

UserForm.displayName = 'UserForm';
